import type { UseCase } from '@contexts/shared/application';
import { uuidValueObject } from '@contexts/shared/domain';
import type { UserRepository } from '@contexts/users/domain';

export type DeleteUserInput = {
	id: string;
};

export type DeleteUserUseCase = UseCase<DeleteUserInput, string>;

export function deleteUserBuilder(userRepository: UserRepository): DeleteUserUseCase {
	return async function deleteUser(input: DeleteUserInput): Promise<string> {
		const id = uuidValueObject().validate('id', input.id);

		return userRepository.delete(id);
	};
}
